import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataModule, Module } from '../shared/interfaces/module.interface';
import { Observable, catchError, map, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment.development';

const API_URL = environment.apiUrl;


@Injectable({
  providedIn: 'root'
})
export class ModulesService {

  modules:DataModule[] = [];
  constructor(private http: HttpClient) { }

  getModules(): Observable<DataModule[]> {
    return this.http.get<Module>(`${API_URL}/modules?sort=title`)
    .pipe(
      map(resp => resp.data),
      retry(1), catchError(this.handleError)
    );
  }

  getModulesOfCourseById(id:string):Observable<DataModule[]>{
    return this.http.get<Module>(`${API_URL}/modules?sort=title&filter[field_course.id][value]=${id}`).pipe(
      map(resp => resp.data),
      retry(1), catchError(this.handleError)
    );
  }

  getModuleById(id:string):Observable<DataModule>{
    return this.http.get<any>(`${API_URL}/modules/${id}`).pipe(
      map(resp => resp.data),
      retry(1), catchError(this.handleError)
    );
  }





  //Manejador de errores
  private handleError(error:any) {
    let errorMessage = '';
    (error.error instanceof ErrorEvent) ?  errorMessage = `Error: ${error.error.message}`
    : errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    return throwError(() => {
        return errorMessage;
    });
  }
}
